// Navigation structure (mega-menu)
import {
  ChartLine,
  AppWindow,
  Megaphone,
  Star,
  BellRing,
  Brain,
  BarChart2,
  Users2,
  Newspaper,
  Zap,
  Rocket,
  Palette,
  Globe2,
  MessageSquare,
  FileText,
  BookOpen,
  LayoutGrid,
  Users,
  Briefcase,
  Handshake,
  Phone,
  Info,
  GitCompare,
  Package,
} from "lucide-react";

export const MEGA_NAV = [
  {
    label: "Services",
    key: "services",
    columns: [
      {
        title: "Growth",
        items: [
          {
            label: "App Store Optimization (ASO)",
            desc: "Rank #1 on iOS & Google Play",
            icon: ChartLine,
            href: "/aso",
          },
          {
            label: "User Acquisition & Campaigns",
            desc: "Apple Search Ads · UAC · Meta · TikTok",
            icon: Megaphone,
            href: "/user-acquisition",
          },
          {
            label: "Influencer & Creator Partnerships",
            desc: "TikTok · Instagram · YouTube · UGC",
            icon: Users2,
            href: "/influencer-marketing",
          },
          {
            label: "Content Marketing & PR",
            desc: "Media outreach · Editorial · SEO",
            icon: Newspaper,
            href: "/content-marketing",
          },
        ],
      },
      {
        title: "Optimise & Measure",
        items: [
          {
            label: "User Retention & Engagement",
            desc: "Push · in-app · onboarding · referrals",
            icon: BellRing,
            href: "/app-retention",
          },
          {
            label: "Analytics & Attribution",
            desc: "Firebase · Mixpanel · Amplitude · SKAdNetwork",
            icon: BarChart2,
            href: "/analytics",
          },
          {
            label: "Advanced Paid Marketing",
            desc: "Programmatic · DSP · Retargeting · Lookalikes",
            icon: Zap,
            href: "/advanced-paid-marketing",
          },
          {
            label: "Ratings & Reviews",
            desc: "Lift ratings from 3.x to 4.5+",
            icon: Star,
            href: "/ratings-reviews",
          },
        ],
      },
      {
        title: "Premium",
        items: [
          {
            label: "GTM Strategy",
            desc: "Launch planning · Positioning · Roadmap",
            icon: Rocket,
            href: "/gtm-strategy",
          },
          {
            label: "Creative Production",
            desc: "Screenshots · Videos · Ad creatives",
            icon: Palette,
            href: "/creative-production",
          },
          {
            label: "International Expansion",
            desc: "15+ markets · Localised ASO · Regional UA",
            icon: Globe2,
            href: "/international-expansion",
          },
          {
            label: "Consultancy With Expert",
            desc: "Audits · Roadmaps · Advisory retainer",
            icon: MessageSquare,
            href: "/consultancy",
          },
        ],
      },
    ],
  },
  {
    label: "Resources",
    key: "resources",
    columns: [
      {
        title: "Learn",
        items: [
          {
            label: "Blog",
            desc: "ASO playbooks, growth notes",
            icon: FileText,
            href: "/blog",
          },
          {
            label: "Resources",
            desc: "Templates, guides, checklists",
            icon: BookOpen,
            href: "/resources",
          },
          {
            label: "Case Studies",
            desc: "Real app growth, audited",
            icon: LayoutGrid,
            href: "/case-studies",
          },
          {
            label: "Agency Comparisons",
            desc: "AppFillip vs Phiture, Yodel & more",
            icon: GitCompare,
            href: "/compare",
          },
          {
            label: "Media Kit",
            desc: "Logos, bios, stats & boilerplate",
            icon: Package,
            href: "/media-kit",
          },
        ],
      },
    ],
  },
  {
    label: "Company",
    key: "company",
    columns: [
      {
        title: "About",
        items: [
          {
            label: "About AppFillip",
            desc: "Jaipur → worldwide since 2022",
            icon: Info,
            href: "/about",
          },
          {
            label: "Careers",
            desc: "Join the growth engine",
            icon: Briefcase,
            href: "/careers",
          },
          {
            label: "Partners",
            desc: "Agencies, affiliates, tech",
            icon: Handshake,
            href: "/partners",
          },
          {
            label: "Contact",
            desc: "Book a call or message us",
            icon: Phone,
            href: "/contact",
          },
        ],
      },
    ],
  },
];
